//Margin component for  multibar, waterfall chart, stackedBar, stackedArea horizontalBar horizontalStacked
// line area scatterPlot heatmap crosstab boxPlot treeMap sankey simplecard

import React from 'react';
import SliderWithInput from '../../SliderWithInput';

interface BasicMarginsProps {
  top: number;
  right: number;
  bottom: number;
  left: number;
  onChange: (option: string, value: number) => void;
  minMax?: { min: number; max: number; step: number };
  iconColor?: string;
}

const BasicMargins: React.FC<BasicMarginsProps> = ({
  top,
  right,
  bottom,
  left,
  onChange,
  minMax = { min: 0, max: 50, step: 1 },
  iconColor,
}) => {
  return (
    <>
      <div
        className="optionDescription"
        style={{
          marginTop: '0px',
          paddingTop: '8px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        MARGIN RESIZE
      </div>
      <div
        className="optionDescription"
        style={{
          paddingTop: '0',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        Top
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={top}
        sliderMinMax={minMax}
        changeValue={(value: number) => onChange('top', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Right
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={right}
        sliderMinMax={minMax}
        changeValue={(value: number) => onChange('right', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Bottom
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={bottom}
        sliderMinMax={minMax}
        changeValue={(value: number) => onChange('bottom', value)}
      />
      <div style={{ marginBottom: '15px' }}>
        <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
          Left
        </div>
        <SliderWithInput
          percent={true}
          sliderValue={left}
          sliderMinMax={minMax}
          changeValue={(value: number) => onChange('left', value)}
        />
      </div>
    </>
  );
};

export default BasicMargins;
